/** Keep order numbers as decimal text so large BigInteger values retain precision. */
export function cleanFulfillmentOrderNumber( input: string ): string {
	return input.trim().replace( /^FO-/i, '' ).trim()
}

export function parseFulfillmentOrderNumber( input: string ): string | undefined {
	const cleaned = cleanFulfillmentOrderNumber( input )
	return /^\d+$/.test( cleaned ) ? cleaned.replace( /^0+(?=\d)/, '' ) : undefined
}
